import { MAX_EMAIL_ATTEMPTS, type Order } from '@hearingaid/shared'

/** What the detail screen shows about the procurement email. The neutral "sending" wait is a
 *  screen state (it depends on the re-check loop), so it stays in OrderDetail. */
export interface SendBannerView {
  kind: 'ok' | 'warn'
  headline?: string
  text: string
}

export function sendBanner(order: Order, submitted: boolean, emailTo: string): SendBannerView | null {
  if (order.email_sent_at !== null) {
    if (!submitted) return null
    const cc = order.submitted_by_email ? `, with a copy to you at ${order.submitted_by_email}` : ''
    return { kind: 'ok', headline: 'Order submitted. Email sent.', text: `The order was emailed to ${emailTo}${cc}.` }
  }
  if (submitted)
    return {
      kind: 'warn',
      headline: 'Order submitted. Email not sent yet.',
      text: `The order is saved, but the email to ${emailTo} hasn't gone out. The app will keep retrying, so there's no need to submit again.`,
    }
  const n = order.email_attempts
  const noun = n === 1 ? 'attempt' : 'attempts'
  if (n >= MAX_EMAIL_ATTEMPTS)
    return {
      kind: 'warn',
      text: `The email to procurement was not sent, and the app has stopped retrying (${n} ${noun}). Send this order to procurement another way.`,
    }
  return { kind: 'warn', text: `The email to procurement is not sent yet (${n} ${noun} so far).` }
}
